import { useFiltersSearch, useQuickSearch, useSearchApi, useStudiesSearch, useVocabSearch } from '../search';
import { IConfig, IModalApi, IToastApi } from '@vivli/shared/infrastructure/interface';
import { IActiveUser, IAssignedAppType, IPlatformSearchHooks } from '@vivli/core/infrastructure/interface';
import { useAppConfigContext, useAssignedAppTypeContext, useModalApiContext, useToastApiContext } from '@vivli/core/infrastructure/context';

interface ISearchInitHook {
    activeUser: IActiveUser;
}

export const useSearchInit = ({ activeUser }: ISearchInitHook): IPlatformSearchHooks => {
    const config = useAppConfigContext();
    const modalApi = useModalApiContext();
    const assignedAppType = useAssignedAppTypeContext();
    const toastApi = useToastApiContext();

    //DEV-1133: these no longer take config. They used to read the Azure Search URL and the query
    //key off it; both now live server-side, and the endpoint comes from the shared REST hook.
    const vocabSearchApi = useVocabSearch();
    const studiesSearchApi = useStudiesSearch();
    const filtersSearchApi = useFiltersSearch();
    const quickSearchApi = useQuickSearch({
        modalApi,
        assignedAppType: assignedAppType.type,
        studiesSearch: studiesSearchApi
    });
    const searchApi = useSearchApi({
        appConfig: config,
        assignedAppType,
        toastApi,
        activeUser,
        vocabSearch: vocabSearchApi,
        studiesSearch: studiesSearchApi,
        filtersSearch: filtersSearchApi
    });

    return {
        vocabSearchApi,
        studiesSearchApi,
        filtersSearchApi,
        quickSearchApi,
        searchApi
    };
};
